import * as client from '../../services/client';
import { TYPES } from '../../common/constants';
import {
  setServiceRequestFormNextStep,
  setServiceRequestFormStep,
  clearServiceRequestFormData,
} from '../actions/serviceRequestForm';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  fetchWalkThroughServiceList,
  setEasyWalkThroughFormData,
} from '../actions/easyWalkThroughForm';
import { setPropertyWalkThroughFormData } from './propertyWalkThroughForm';
import { startFormLoading, stopFormLoading } from './loader';

import { store } from '..';
import { selectPropertyWalkThroughFormData } from '../selectors/propertyWalkThroughForm';
import { fetchPropertyCounts } from './properties';
import { selectAuthenticatedUser } from '../selectors/auth';
import { fetchSuiteCounts } from './suites';
import { selectEasyWalkThroughFormData } from '../selectors/easyWalkThroughForm';
import { setValidation } from './validation';

export const saveScheduledAppointment =
  (formData, serviceRequestId) => (dispatch) => {
    formData['ticketId'] = serviceRequestId;
    dispatch(startFormLoading());

    return client
      .saveScheduledAppointment(formData)
      .then((response) => {
        dispatch(stopFormLoading());
        if (response.ok || response.status === 200) {
          response.json().then((responsejson) => {
            toast.success(' ⓘ Appointment has been scheduled.', {
              autoClose: 10000,
              position: 'top-center',
            });
            dispatch(saveStatusDone(serviceRequestId, responsejson.data));
            dispatch(setValidation('Schedule'));
          });
        } else {
          toast.error(
            ' 🚫 Something went wrong with adding a service request, please try again.',
            { autoClose: 12000, position: 'top-center' }
          );
        }
      })
      .catch((error) => {
        dispatch(stopFormLoading());
        toast.error(
          '🚫 Something went wrong with adding a service request, please try again.',
          { autoClose: 12000, position: 'top-center' }
        );
      });
  };

const saveStatusDone = (id, payload) => ({
  type: TYPES.SAVE_STATUS_DONE,
  id,
  payload,
});

export const fetchServiceRequestByIdDone = (payload) => ({
  type: TYPES.FETCH_SERVICE_REQUEST_BY_ID_DONE,
  payload,
});

export const UpdateServiceRequestDone = (payload) => ({
  type: TYPES.UPDATE_SERVICE_REQUEST_DONE,
  payload,
});

export const clearServiceRequestDone = () => ({
  type: TYPES.CLEAR_SERVICE_REQUEST,
});

export const fetchServiceRequestById = (id) => (dispatch, getState) => {
  return client.getServiceRequestById(id).then((response) => {
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        dispatch(fetchServiceRequestByIdDone(responsejson));
      });
    }
  });
};

const saveServiceRequestDone = (payload) => ({
  type: TYPES.SAVE_SERVICE_REQUEST_DONE,
  payload,
});

export const saveServiceRequest =
  (serviceRequest, type, from) => (dispatch) => {
    dispatch(startFormLoading());
    return client
      .saveServiceRequest(serviceRequest)
      .then((response) => {
        dispatch(stopFormLoading());
        if (response.ok || response.status === 200) {
          response.json().then((responsejson) => {
            if (responsejson.statusCode === 200) {
              toast.success('ⓘ Service request created successfully.', {
                autoClose: 12000,
                position: 'top-center',
              });
              const attachments =
                responsejson.data[0] && responsejson.data[0].attachment
                  ? responsejson.data[0].attachment
                  : [];
              if (attachments && attachments.length > 0) {
                let images = JSON.parse(attachments);
                if (images.length > 0) {
                  for (var i = 0; i < images.length; i++) {
                    let doc = {
                      name: 'Document' + i.toString(),
                      description: 'through service request',
                      type: 'Image',
                      document: images[i],
                    };
                    let data = {
                      ItemId: responsejson.data[0].id,
                      Name: 'DOCUMENTS',
                      Type: 'DOCUMENTS',
                      Data: JSON.stringify(doc).toString(),
                      UserId: serviceRequest.creatorId,
                    };
                    addDocuments(data, dispatch);
                  }
                }
              }
              dispatch(saveServiceRequestDone(responsejson.data));
              if (from === 'Suite') {
                dispatch(fetchSuiteCounts(serviceRequest.suiteId));
              }
              if (from === 'Property') {
                let user = selectAuthenticatedUser(store.getState());
                dispatch(
                  fetchPropertyCounts(
                    serviceRequest.propertyId,
                    user.id,
                    user.roles[0].role.name
                  )
                );
              }
              if (type === 'developerWalkthrough') {
                let srData = responsejson.data[0];
                let data = {
                  id: srData.id,
                  ticketNumber: srData.ticketNumber,
                  subject: srData.subject,
                  description: srData.description,
                  issueType: { name: srData.serviceType },
                  asset: {
                    serialNumber: srData.serialNumber
                      ? srData.serialNumber
                      : '',
                    item: { name: srData.itemName },
                  },
                  area: { name: serviceRequest.areaName },
                  attachment: serviceRequest.Attachment,
                };

                let easyWalkThroughFormData = selectEasyWalkThroughFormData(
                  store.getState()
                );
                dispatch(
                  setEasyWalkThroughFormData({
                    walkThroughServiceRequests: [
                      ...easyWalkThroughFormData.walkThroughServiceRequests,
                      data,
                    ],
                  })
                );
                dispatch(
                  fetchWalkThroughServiceList(
                    responsejson.data[0].walkthroughId
                  )
                );
              }

              if (type === 'AddAnother') {
                if (from === 'Property') {
                  dispatch(
                    clearServiceRequestFormData({
                      property_id: serviceRequest.propertyId,
                      propertyId: serviceRequest.propertyId,
                    })
                  );
                  dispatch(setServiceRequestFormStep(0));
                } else if (from === 'Suite') {
                  dispatch(
                    clearServiceRequestFormData({
                      property_id: serviceRequest.propertyId,
                      propertyId: serviceRequest.propertyId,
                      suite_id: serviceRequest.suiteId,
                      suiteId: serviceRequest.suiteId,
                    })
                  );
                  dispatch(setServiceRequestFormStep(0));
                } else {
                  dispatch(clearServiceRequestFormData({}));
                  dispatch(setServiceRequestFormStep(0));
                }
              } else {
                if (type === 'walkthrough') {
                  let srData = responsejson.data[0];
                  let data = {
                    id: srData.id,
                    ticketNumber: srData.ticketNumber,
                    subject: srData.subject,
                    description: srData.description,
                    issueType: { name: srData.serviceType },
                    asset: {
                      serialNumber: srData.serialNumber
                        ? srData.serialNumber
                        : '',
                      item: { name: srData.itemName },
                    },
                  };
                  let propertyWalkThroughFormData =
                    selectPropertyWalkThroughFormData(store.getState());

                  dispatch(
                    setPropertyWalkThroughFormData({
                      serviceRequests: [
                        ...propertyWalkThroughFormData.serviceRequests,
                        data,
                      ],
                    })
                  );

                  dispatch(
                    setPropertyWalkThroughFormData({
                      serviceRequest: responsejson.data[0],
                    })
                  );
                  // fastfetchServiceRequestById(responsejson.data[0].id,dispatch)
                  dispatch(
                    fetchServiceRequestByAssetId(
                      serviceRequest.assetId,
                      responsejson.data[0].walkthroughId,
                      true
                    )
                  );
                }
                localStorage.setItem('ticketId', responsejson.data[0].ticketId);
                localStorage.setItem(
                  'ticketNumber',
                  responsejson.data[0].ticketNumber
                );
                localStorage.setItem(
                  'serviceRequestId',
                  responsejson.data[0].id
                );
                dispatch(setServiceRequestFormNextStep());
              }
            } else {
              toast.error(
                ' 🚫 Something went wrong with adding a service request, please try again.',
                { autoClose: 5000, position: 'top-center' }
              );
            }
          });
        } else {
          toast.error(
            ' 🚫 Something went wrong with adding a service request, please try again.',
            { autoClose: 12000, position: 'top-center' }
          );
        }
      })
      .catch((error) => {
        dispatch(stopFormLoading());
        toast.error(
          ' 🚫 Something went wrong with adding a service request, please try again.',
          { autoClose: 12000, position: 'top-center' }
        );
      });
  };

export const updateServiceRequest = (serviceRequest, type) => (dispatch) => {
  dispatch(startFormLoading());
  dispatch(
    setEasyWalkThroughFormData({ walkThroughServiceRequestListLoading: true })
  );
  return client
    .updateServiceRequest(serviceRequest)
    .then((response) => {
      dispatch(stopFormLoading());
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson.data) {
            toast.success('ⓘ Service request updated successfully.', {
              autoClose: 12000,
              position: 'top-center',
            });
            if (type === 'EditServiceRequest') {
              dispatch(UpdateServiceRequestDone(responsejson.data));
            }
            if (responsejson.data.walkthroughId) {
              dispatch(
                fetchWalkThroughServiceList(responsejson.data.walkthroughId)
              );
            }
          }
        });
      } else {
        dispatch(
          setEasyWalkThroughFormData({
            walkThroughServiceRequestListLoading: false,
          })
        );
        toast.error(
          ' 🚫 Something went wrong with updating a service request, please try again.',
          { autoClose: 12000, position: 'top-center' }
        );
      }
    })
    .catch((error) => {
      dispatch(
        setEasyWalkThroughFormData({
          walkThroughServiceRequestListLoading: false,
        })
      );
      toast.error(
        ' 🚫 Something went wrong with updating a service request, please try again.',
        { autoClose: 12000, position: 'top-center' }
      );
    });
};

export const fetchServiceRequestByAssetId =
  (assetId, walkthroughId, type) => (dispatch) => {
    return client
      .fetchServiceRequestsByAssetId(assetId, walkthroughId)
      .then((response) => {
        if (response.status === 200 || response.ok) {
          response.json().then((responsejson) => {
            dispatch(
              setPropertyWalkThroughFormData({ serviceRequests: responsejson })
            );
            if (type !== true) {
              dispatch(
                setPropertyWalkThroughFormData({
                  serviceRequest: responsejson[0],
                })
              );
            }
          });
        }
      });
  };

const addDocuments = (data, dispatch) => {
  return client.addFaqsNotesDocuments(data).then((response) => {
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        // alert(data.Type + ' added successfully')
        dispatch(saveFaqsNotesDocumentsDone(responsejson.data));
      });
    } else {
      toast.error(' 🚫 Something Went Wrong !', {
        autoClose: 12000,
        position: 'top-center',
      });
    }
  });
};

const saveFaqsNotesDocumentsDone = (payload) => ({
  type: TYPES.SAVE_FAQ_NOTES_DOCUMENTS_DONE,
  payload,
});
